'use strict'


import PopinManager from "./popinManage";

const Campagne = {
    elt: null,
    imageElt: null,
    cookieName: null,

    init: function () {
        Campagne.elt = document.querySelector('.c-campagne');

        if (Campagne.elt) {
            Campagne.cookieName = `popin_campagne_${Campagne.elt.dataset.popinId}`;

            Campagne.imageElt = Campagne.elt?.querySelector('.c-campagne__img img');
            if (Campagne.imageElt) {
                Campagne.handleImageSwitch();
                Campagne.checkCookie();
                Campagne.event();
            }
        }
    },

    event: function () {
        const closeBtn = Campagne.elt.querySelector('.c-campagne__close');
        const overlay = Campagne.elt.querySelector('.c-campagne__overlay');
        const ctaLinks = Campagne.elt.querySelectorAll('.c-campagne__ctas a');
        if (ctaLinks.length) {
            ctaLinks.forEach(link => link.addEventListener('click', Campagne.closePopin));
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', Campagne.closePopin);
        }
        if (overlay) {
            overlay.addEventListener('click', Campagne.closePopin);
        }
        window.addEventListener('resize', Campagne.handleImageSwitch.bind(this));
    },

    handleImageSwitch: function () {
        const isMobile = window.innerWidth <= 1024;
        const imgContainer = Campagne.elt.querySelector('.c-campagne__img');
        const newSrc = isMobile ? imgContainer.dataset.imgMobile : imgContainer.dataset.imgDesktop;

        if (Campagne.imageElt.src !== newSrc) {
            Campagne.imageElt.src = newSrc;
        }
    },

    checkCookie: function () {
        const popinCookie = Campagne.getCookie(Campagne.cookieName);

        if (popinCookie && popinCookie === 'false') {
            Campagne.elt.setAttribute('aria-hidden', 'true');
        } else {
            Campagne.openPopin();
        }
    },
    openPopin: function () {
        Campagne.elt.classList.add('show--');
        Campagne.elt.removeAttribute('aria-hidden');
        Campagne.setCookie(Campagne.cookieName, 'true', 1);
        document.body.classList.add('no-scroll');
        PopinManager.focusFirstElement(Campagne.elt);
        document.addEventListener("keydown", (e) => PopinManager.trapFocus(Campagne.elt, e, Campagne.closePopin));
    },
    closePopin: function () {
        Campagne.elt.setAttribute('aria-hidden', 'true');
        Campagne.elt.classList.remove('show--');
        document.body.classList.remove('no-scroll');
        Campagne.setCookie(Campagne.cookieName, 'false', 1);
        document.removeEventListener("keydown", (e) => PopinManager.trapFocus(Campagne.elt, e, Campagne.closePopin));
    },
    setCookie: function (name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
    },

    getCookie: function (name) {
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            let [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }
}

export default Campagne;
